<template>
    <div class="data-card">
        <div class="data-card-toolbar">
            <span class="paginator-report">
                <strong>{{ state.origins.length }}</strong> {{ state.origins.length === 1 ? 'endereço autorizado' : 'endereços autorizados' }}
                a consumir a API com o token deste cliente.
            </span>

            <div class="data-page-actions">
                <Button type="button" icon="pi pi-plus" label="Registrar endereço" @click="openRegisterModal" />
            </div>
        </div>

        <DataTable class="data-table" lazy :value="state.origins" :loading="state.loading.origins" dataKey="id"
            :autoLayout="true" responsiveLayout="scroll">

            <template #empty>
                <div class="data-empty">
                    <i class="pi pi-inbox"></i>
                    <span>Nenhum endereço autorizado. O cliente não conseguirá consumir a API.</span>
                </div>
            </template>

            <Column field="id" header="ID" class="col-id">
                <template #body="slotProps">
                    <span class="record-id">{{ slotProps.data.id }}</span>
                </template>
            </Column>

            <Column field="name" header="Nome">
                <template #body="slotProps">
                    <span v-if="slotProps.data.name" class="record-name">{{ slotProps.data.name }}</span>
                    <span v-else class="empty-value">—</span>
                </template>
            </Column>

            <Column field="ip" header="Endereço IP">
                <template #body="slotProps">
                    <span class="mono-chip mono-chip-sm" v-tooltip.bottom="{ value: slotProps.data.ip, showDelay: 300, hideDelay: 300 }">{{ slotProps.data.ip }}</span>
                </template>
            </Column>

            <Column class="col-actions">
                <template #header>
                    Ações
                </template>
                <template #body="slotProps">
                    <div class="flex justify-content-end">
                        <Button class="table-action-button p-button-icon-only" type="button" icon="pi pi-trash"
                            @click="openDeleteModal(slotProps.data)"
                            v-tooltip.left="{ value: 'Remover endereço', showDelay: 1000, hideDelay: 300 }" />
                    </div>
                </template>
            </Column>

        </DataTable>
    </div>

    <Dialog class="data-dialog" v-model:visible="state.registerAddressModal" :style="{ width: '30rem' }" modal
        header="Registrar endereço" @update:visible="handleClose">

        <form class="data-form-grid data-form-single" @submit.prevent="tryToRegisterAddress">

            <div class="form-field">
                <label for="origin-name">Nome</label>
                <InputText id="origin-name" type="text" v-model="state.name" autofocus />
            </div>

            <div class="form-field">
                <label for="origin-ip">Endereço IP</label>
                <InputText id="origin-ip" type="text" v-model="state.ip" placeholder="000.000.000.000" />
                <span class="form-hint">O IP precisa ser idêntico ao de origem da requisição do cliente.</span>
            </div>

            <button type="submit" class="hidden"></button>
        </form>

        <template #footer>
            <Button class="p-button-text" type="button" label="Cancelar" @click="state.registerAddressModal = false" />
            <Button :loading="state.loading.register" type="button" label="Registrar endereço" icon="pi pi-check"
                @click="tryToRegisterAddress" />
        </template>

    </Dialog>

    <Dialog class="data-dialog" v-model:visible="state.deleteAddressModal" :style="{ width: '32rem' }" modal
        header="Remover endereço">

        <div class="data-form-grid data-form-single">

            <div class="data-dialog-subject">
                <span class="pill pill-muted">ID {{ state.originToDelete.id }}</span>
                <span>{{ state.originToDelete.name }}</span>
            </div>

            <Message severity="error" sticky :closable="false">
                Ao remover o endereço {{ state.originToDelete.ip }}, as requisições vindas dele passam a ser
                recusadas imediatamente.
            </Message>

        </div>

        <template #footer>
            <Button class="p-button-text" type="button" label="Cancelar" @click="state.deleteAddressModal = false" />
            <Button class="p-button-danger" :loading="state.loading.delete" type="button" icon="pi pi-trash"
                label="Remover endereço" @click="tryToDeleteAddress" />
        </template>

    </Dialog>
</template>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import Message from 'primevue/message'
import { reactive } from 'vue'
import services from '../../../services'
import useNotificationToast from '../../../composables/useNotificationToast'
import { useStore } from 'vuex'

export default {
    components: { InputText, Button, DataTable, Column, Dialog, Message },

    props: {
        client: {
            type: Object
        },
    },

    setup(props) {
        const state = reactive({

            name: null,
            ip: null,
            origins: [],

            originToDelete: {},

            loading: {
                register: false,
                origins: false,
                delete: false,
            },

            registerAddressModal: false,
            deleteAddressModal: false,

        })

        const store = useStore()
        const { success, error } = useNotificationToast()

        loadAlowedOrigins()

        function loadAlowedOrigins() {
            state.loading.origins = true

            const token = store.getters.getToken
            const clientId = props.client.id

            services.clients.getAlowedAdresses({ id: clientId, token })
                .then((response) => {
                    state.origins = response.data
                })
                .catch(() => {
                    error("Não foi possível carregar os endereços autorizados.")
                })
                .finally(() => { state.loading.origins = false })

        }

        function openRegisterModal() {
            state.name = null
            state.ip = null
            state.registerAddressModal = true
        }

        function handleClose() {
            state.name = null
            state.ip = null
        }

        function tryToRegisterAddress() {

            if (!state.name || !state.ip) {
                return error('Verifique todos os campos!')
            }

            state.loading.register = true
            const clientId = props.client.id
            const name = state.name
            const ip = state.ip
            const token = store.getters.getToken

            services.clients.registerOrigin({ id: clientId, name, ip, token }).then(() => {

                success('Endereço registrado com sucesso')
                loadAlowedOrigins()
                state.registerAddressModal = false
                state.name = null
                state.ip = null

            }).catch(() => {
                error("Não foi possível registrar o endereço.")
            }).finally(() => {
                state.loading.register = false
            })
        }

        function openDeleteModal(origin) {
            state.originToDelete = origin
            state.deleteAddressModal = true
        }

        function tryToDeleteAddress() {

            state.loading.delete = true
            const clientId = props.client.id
            const ip = state.originToDelete.ip
            const token = store.getters.getToken

            services.clients.deleteOrigin({ id: clientId, ip, token }).then(() => {

                success('Endereço deletado com sucesso')
                state.deleteAddressModal = false
                loadAlowedOrigins()
            }).catch(() => {
                error("Não foi possível deletar o endereço.")
            }).finally(() => {
                state.loading.delete = false
            })
        }

        return {
            state,
            openRegisterModal,
            handleClose,
            tryToRegisterAddress,
            openDeleteModal,
            tryToDeleteAddress
        }

    }
}
</script>
